module.exports = __webpack_public_path__ + "img/french-3.289c475e.png";